module.exports = __webpack_public_path__ + "img/naples_grey.0fec2868.jpeg";